/** Textes des pages publiques hors landing (Contact et pages légales) — français, langue de référence :
 *  en.ts et pt.ts doivent suivre exactement la même forme (cf. type PublicContent). */
const todo = '[À compléter]'

export const fr = {
  common: {
    backHome: '← Retour à l’accueil',
    updatedPrefix: 'Dernière mise à jour :',
    updatedAt: '10 octobre 2026',
    draftBanner: 'Texte provisoire, en cours de rédaction : les passages entre crochets seront complétés.',
    todo,
    footerRights: '© 2026 Boutiklic kaatomi-laafou. Tous droits réservés.',
    footerNavAria: 'Pages légales',
    footerBilling: 'Conformité de facturation',
    footerPrivacy: 'Politique de confidentialité',
    footerTerms: 'Conditions d’utilisation (CGV)',
    footerNotice: 'Mentions légales',
    cities: 'Conakry (Guinée)',
    whatsappMessage: 'Bonjour, j’ai une question sur Boutiklic.',
    hours: [{ label: 'Lundi – vendredi', value: '8 h – 18 h' }],
    contactSupportLegal: 'Contacter le support légal',
  },

  notice: {
    docTitle: 'Mentions légales',
    intro: 'Informations légales relatives à l’éditeur et à l’hébergeur du service Boutiklic.',
    eyebrow: 'Informations légales & juridiques',
    tocTitle: 'Sommaire & navigation rapide',
    tocAria: 'Sommaire des sections légales',
    toc: ['Éditeur du service', 'Hébergement', 'Propriété intellectuelle', 'Données personnelles', 'Responsabilité & Liens', 'Contact & Juridiction'],
    editorTitle: 'Éditeur du service',
    companyLabel: 'Raison sociale',
    companyValue: `Boutiklic Technologies ${todo}`,
    formLabel: 'Forme juridique et capital',
    formValue: '[SAS au capital de 10 000 000 GNF - À compléter]',
    seatLabel: 'Siège social',
    regLabel: 'Immatriculation & registre légal',
    directorLabel: 'Directeur de la publication',
    directorValue: '[Direction générale Boutiklic - À compléter]',
    contactLabel: 'Contact officiel',
    hostingTitle: 'Hébergement',
    hostingBefore: 'Le service et les données de la plateforme ',
    hostingAfter: ' sont hébergés auprès d’infrastructures cloud hautement sécurisées conformes aux normes internationales :',
    hostingVisit: 'Visiter l’hébergeur',
    ipTitle: 'Propriété intellectuelle',
    ip1: 'L’ensemble des éléments constituant le service Boutiklic (notamment la marque, les logos, textes, interfaces graphiques, code source, bases de données et documentation logicielle) est protégé par les lois nationales et internationales relatives à la propriété intellectuelle et aux droits d’auteur.',
    ip2Before: 'Toute reproduction, représentation, modification, diffusion ou exploitation totale ou partielle des éléments du site et de l’application SaaS, sans l’accord préalable exprès et écrit de ',
    ip2After: ', est strictement interdite et est susceptible de constituer un délit de contrefaçon.',
    ipNote: 'Les marques, dénominations commerciales et logos de tiers apparaissant sur la plateforme demeurent la propriété exclusive de leurs détenteurs respectifs.',
    dataTitle: 'Données personnelles & Confidentialité',
    data1: 'Boutiklic accorde une importance capitale à la confidentialité et à la sécurité des données des commerçants et de leurs clients. Les traitements de données effectués dans le cadre de l’exploitation de la plateforme respectent les principes de transparence, de proportionnalité et de sécurité conformes aux meilleures pratiques réglementaires.',
    data2: 'Pour en savoir plus sur la collecte de vos données, l’exercice de vos droits d’accès, de rectification ou de suppression, ou pour contacter notre délégué à la protection des données :',
    dataButton: 'Consulter la politique de confidentialité',
    liabilityTitle: 'Limitation de responsabilité',
    liability1: 'Boutiklic met tout en œuvre pour assurer l’exactitude des informations et le fonctionnement continu de ses services. Toutefois, Boutiklic ne saurait être tenu responsable des interruptions momentanées pour maintenance, des erreurs involontaires ou de l’inadéquation de son service aux besoins spécifiques d’un utilisateur particulier.',
    liability2: 'Les liens hypertextes éventuellement présents sur la plateforme dirigeant vers des sites externes ne sauraient engager la responsabilité de Boutiklic quant à leur contenu ou leurs pratiques de gestion de données.',
    ctaTag: 'Support réglementaire',
    ctaTitle: 'Une question d’ordre juridique ou réglementaire ?',
    ctaText: 'Notre équipe juridique et conformité est disponible pour répondre à vos demandes relatives aux contrats commerçants, à la protection des données ou aux partenariats.',
    ctaHint: 'Réponse garantie sous 24 à 48 heures ouvrées',
  },

  terms: {
    docTitle: 'Conditions Générales de Vente',
    intro: 'Conditions applicables à l’abonnement et à l’utilisation du service Boutiklic.',
    eyebrow: 'Conditions légales & contractuelles',
    draftTitle: 'Document en cours de finalisation légale',
    draftText: 'Texte provisoire, en cours de rédaction : les passages entre crochets seront complétés prochainement.',
    tocTitle: 'Navigation rapide & sommaire',
    tocAria: 'Sommaire interactif',
    toc: ['Objet', 'Abonnement & Tarifs', 'Résiliation', 'Responsabilité', 'Droit & Litiges'],
    s1Title: 'Objet',
    s1Lead: 'Les présentes conditions régissent l’accès et l’utilisation du service Boutiklic (caisse, gestion de stock, facturation).',
    modules: [
      { title: 'Caisse tactile', text: 'Point de vente fluide adapté à la vente en boutique physique.' },
      { title: 'Gestion de stock', text: 'Inventaire dynamique, seuils d’alerte et gestion multi-dépôts.' },
      { title: 'Facturation', text: 'Devis, tickets conformes, reçus WhatsApp et suivi comptable.' },
    ],
    s2Title: 'Abonnement et tarifs',
    s2Lead: 'Offres, tarifs et modalités de paiement :',
    recapTitle: 'Modalités prévues au contrat',
    recap: [
      { label: 'Formules d’abonnement', value: 'Mensuelle ou Annuelle', text: 'Facturation anticipée à date d’anniversaire de compte.' },
      { label: 'Devises prises en charge', value: 'GNF / FCFA / EUR', text: 'Tarification transparente selon votre pays d’exercice.' },
      { label: 'Paiements acceptés', value: 'Mobile Money & Cartes (à venir)', text: 'Orange Money, MTN, Wave, cartes bancaires Visa/Mastercard.' },
    ],
    s3Title: 'Résiliation',
    s3Lead: 'Conditions et délais de résiliation :',
    s3Bullets: [
      '• La souscription mensuelle sans engagement peut être interrompue à tout moment depuis l’espace d’administration du compte client.',
      '• En cas de résiliation, le client bénéficie d’une durée de 30 jours pour exporter librement ses catalogues de données, journaux de ventes et écritures comptables sous format CSV / Excel.',
    ],
    s4Title: 'Responsabilité',
    s4Lead: 'Limites de responsabilité de l’éditeur et obligations de l’utilisateur :',
    dutyEditorTitle: 'Obligations de l’éditeur',
    dutyEditorText: 'Mise en œuvre des moyens raisonnables pour garantir la disponibilité 24/7 de l’infrastructure logicielle, sauvegardes chiffrées automatiques journalières.',
    dutyUserTitle: 'Obligations de l’utilisateur',
    dutyUserText: 'Confidentialité stricte des identifiants d’accès administrateur et caissiers, respect de la législation commerciale et fiscale en vigueur.',
    s5Title: 'Droit applicable et litiges',
    s5Lead: 'Droit applicable et juridiction compétente :',
    s5P1: 'En cas de contestation ou de litige relatif à l’exécution ou l’interprétation des présentes conditions, les parties s’engagent à privilégier une concertation amiable sous un délai de trente (30) jours ouvrés.',
    s5P2: 'À défaut d’accord amiable, les tribunaux compétents du siège de la juridiction de Conakry seront exclusivement saisis.',
    ctaTag: 'Assistance contractuelle',
    ctaTitle: 'Une question sur nos conditions de vente ?',
    ctaText: 'Notre équipe juridique et commerciale est à votre écoute pour clarifier les modalités de souscription et vos engagements contractuels.',
    ctaButton: 'Contacter l’équipe commerciale',
  },

  privacy: {
    docTitle: 'Protection des données marchandes',
    intro: 'Comment Boutiklic collecte, utilise et protège les données de votre boutique et de vos clients.',
    eyebrow: 'Protection des données & Confidentialité',
    tocTitle: 'Sommaire interactif',
    tocAria: 'Sommaire interactif',
    toc: ['Données collectées', 'Finalités', 'Sous-traitants', 'Conservation', 'Vos droits'],
    s1Title: 'Données collectées',
    s1Lead: 'Données de compte (nom, numéro de téléphone ou e-mail), données de boutique (produits, stocks, ventes, devis, factures) et données de vos clients que vous saisissez dans l’application.',
    kinds: [
      { title: 'Données de compte', text: 'Nom commercial, téléphone portable gérant et e-mail de connexion.' },
      { title: 'Données de boutique', text: 'Catalogue produits, stocks, ventes en caisse, devis & facturation.' },
      { title: 'Fichier de vos clients', text: 'Coordonnées clients et historique d’achats saisis manuellement.' },
    ],
    s2Title: 'Finalités',
    s2Lead: 'Fournir le service (caisse, stock, facturation), sécuriser l’accès (code de vérification par SMS) et assurer la synchronisation entre vos appareils.',
    purposes: [
      { title: 'Exécution du service', text: 'Pilotage de votre point de vente : encaissement rapide, inventaire, réapprovisionnement et édition de justificatifs fiscaux.' },
      { title: 'Sécurité de l’accès', text: 'Vérification par code à usage unique (OTP) envoyé par SMS ou e-mail pour protéger votre caisse des intrusions.' },
      { title: 'Synchronisation', text: 'Mise à jour instantanée et sans fil de vos tickets, stocks et prix entre votre terminal, tablette et mobile.' },
    ],
    s3Title: 'Sous-traitants',
    s3Lead: `Hébergement : OVH. Envoi de SMS : prestataires de messagerie. Stockage de fichiers : ${todo}.`,
    subHostTitle: 'Hébergement Cloud principal',
    subHostText: 'OVH Groupe SAS — Datacenters certifiés situés en France / UE',
    subHostTag: 'Conforme RGPD',
    subSmsTitle: 'Envoi de SMS transactionnels',
    subSmsText: 'Prestataires spécialisés en acheminement de codes OTP & alertes',
    subSmsTag: 'Messagerie agréée',
    subFilesTitle: 'Stockage de fichiers',
    subFilesTag: 'En cours de spécification',
    s4Title: 'Conservation',
    s4Lead: 'Durée de conservation des données :',
    boxTitle: 'Précisions contractuelles en cours de rédaction :',
    boxItems: [
      'Conservation active garantie pendant toute la durée légale de souscription au service Boutiklic.',
      'Sauvegarde des pièces comptables et factures conformément aux obligations légales fiscales.',
      'Délai de réversibilité et d’export complet des données commerçant lors de la résiliation.',
    ],
    s5Title: 'Vos droits',
    s5Lead: 'Vous pouvez demander l’accès, la rectification ou la suppression de vos données en écrivant à :',
    rights: [
      { title: 'Droit d’accès', text: 'Consulter l’intégralité de vos données' },
      { title: 'Rectification', text: 'Mettre à jour les informations erronées' },
      { title: 'Suppression', text: 'Droit à l’effacement définitif' },
      { title: 'Portabilité', text: 'Export aux formats standards (CSV, JSON)' },
    ],
    channelLabel: 'Canal dédié aux demandes RGPD / Confidentialité :',
    channelButton: 'Écrire au responsable',
    ctaTag: 'Assistance & Conformité',
    ctaTitle: 'Une question sur la gestion de vos données ?',
    ctaText: 'Notre équipe dédiée à la conformité et à la protection des données vous accompagne et répond à toutes vos questions en toute transparence.',
    ctaButton: 'Exercer mes droits / Contacter le DPO',
  },

  billing: {
    docTitle: 'Conformité de facturation',
    intro: 'Informations sur la conformité des documents de facturation émis avec Boutiklic.',
    eyebrow: 'Conformité & Réglementation Fiscale',
    tocTitle: 'Sommaire du document',
    tocAria: 'Sommaire du document',
    toc: ['Documents émis', 'Agrément'],
    s1Title: 'Documents émis',
    s1Lead: 'Boutiklic permet d’émettre des devis, tickets et factures. Les mentions obligatoires dépendent de la réglementation de votre pays.',
    docs: [
      { title: 'Devis', text: 'Devis proforma chiffrés, estimation claire avant vente avec durée de validité paramétrable.' },
      { title: 'Tickets', text: 'Tickets de caisse instantanés, reçus thermiques compacts ou digitaux (SMS / WhatsApp).' },
      { title: 'Factures', text: 'Factures officielles conformes, numérotation séquentielle, TVA/taxes et traçabilité inviolable.' },
    ],
    localTitle: 'Adaptation aux réglementations locales',
    localText: 'L’interface Boutiklic intègre les champs d’identification fiscale (NIF, RCCM, clé d’immatriculation TVA) et permet d’ajuster les taux d’imposition selon le pays d’exercice (Guinée, Sénégal, zone UEMOA/CEDEAO, France et international).',
    s2Title: 'Agrément',
    s2Before: 'Statut d’agrément officiel de la solution de facturation :',
    s2After: '. Ne pas publier de mention d’agrément sans justificatif.',
    statusLabel: 'Statut officiel',
    statusTag: 'En cours de qualification',
    statusTitle: 'Certification et agrément administratif',
    statusText: 'Les références d’agrément ministériel ou fiscal ne sont affichées qu’après délivrance des attestations et récépissés formels de conformité.',
    transparency: 'Engagement de transparence Boutiklic : aucune fausse mention n’est imputée aux documents avant validation juridique.',
    ctaTag: 'Support Réglementaire & Fiscal',
    ctaTitle: 'Une question sur la conformité de vos factures ?',
    ctaText: 'Notre équipe d’assistance vous accompagne pour paramétrer vos mentions obligatoires et adapter vos justificatifs à votre législation locale.',
    ctaButton: 'Contacter le pôle conformité',
  },

  contact: {
    docTitle: 'Contact',
    badge: 'Contact & Support',
    h1: 'Parlons de votre boutique.',
    introBefore: 'Une question, une démonstration, un problème technique : notre équipe répond en ',
    langs: ['français', 'anglais', 'portugais'],
    introSep1: ', en ',
    introSep2: ' et en ',
    addressTitle: 'Adresse',
    phoneTitle: 'Téléphone',
    phoneBadge: 'Ligne directe',
    whatsappTitle: 'WhatsApp',
    whatsappBadge: 'En ligne',
    whatsappButton: 'Écrire sur WhatsApp',
    hoursTitle: 'Horaires',
    asideAria: 'Canaux d’assistance directe',
    formAria: 'Formulaire de contact',
    fullName: 'Nom complet',
    fullNamePh: 'Votre nom',
    shopName: 'Nom de la boutique',
    shopNamePh: 'Boutique Mariama',
    email: 'E-mail',
    emailPh: 'vous@exemple.com',
    phone: 'Téléphone',
    phonePh: '+224 620 00 00 00',
    subject: 'Sujet',
    topics: {
      DEMO: 'Demande de démonstration',
      SUPPORT: 'Assistance & Support technique',
      PRICING: 'Questions sur les abonnements & tarifs',
      PARTNERSHIP: 'Partenariat & Distribution',
      OTHER: 'Autre demande',
    },
    message: 'Message',
    messagePh: 'Décrivez votre besoin...',
    minChars: 'Au moins 10 caractères.',
    attachment: 'Pièce jointe',
    optional: '(optionnel)',
    dropLink: 'Téléverser un document',
    dropOr: 'ou glisser-déposer',
    dropHint: 'PNG, JPG, PDF · 3 fichiers max, 5 Mo chacun',
    remove: 'Retirer',
    honeypot: 'Ne pas remplir',
    send: 'Envoyer le message',
    sending: 'Envoi…',
    privacyNote: 'Vos informations sont confidentielles et sécurisées. Aucun message indésirable.',
    successTitle: 'Message envoyé.',
    successText: 'Merci ! Nous vous répondrons dès que possible par e-mail ou par téléphone.',
    tooMany: 'Vous avez envoyé trop de messages. Réessayez dans une heure ou écrivez-nous sur WhatsApp.',
    fileType: '« {name} » : format non supporté (images JPEG, PNG, WebP ou PDF).',
    fileTooBig: '« {name} » dépasse 5 Mo.',
    fileMax: '3 pièces jointes au maximum.',
    unitKb: 'Ko',
    unitMb: 'Mo',
  },
}

export type PublicContent = typeof fr
